var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaChartTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.2286L6.57143 8.65714L10.2286 12.3143L17.5429 5",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.11426,
    y: 10.9424,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4286,
    y: 10.9424,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2572,
    y: 9.11426,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0857,
    y: 7.28613,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.28577,
    y: 12.7715,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 12.7715,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.94287,
    y: 12.7715,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2572,
    y: 12.7715,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0857,
    y: 10.9424,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.02856,
    y: 11.8574,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3429,
    y: 11.8574,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1714,
    y: 10.0283,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5.19995,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5143,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8.85718,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1714,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 5.19995,
    y: 11.8574,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5143,
    y: 11.8574,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3429,
    y: 10.0283,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1714,
    y: 8.2002,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 3.37146,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6857,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 7.02856,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3429,
    y: 13.6855,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1714,
    y: 11.8574,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 6.11426,
    y: 12.7715,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4286,
    y: 12.7715,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2572,
    y: 10.9424,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0857,
    y: 9.11426,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 4.28577,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 6.11426,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4286,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 2.45715,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 9.77148,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 7.94287,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2572,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0857,
    y: 12.7715,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0857,
    y: 14.5996,
    width: 0.914286,
    height: 0.914286,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChartTypeIcon);
export default __webpack_public_path__ + "static/media/areaChartTypeIcon.9bbbe0d93bbfae06cbf69feafa6e6751.svg";
export { ForwardRef as ReactComponent };